const Settings = {
    api_url: process.env.REACT_APP_API_URL as string | undefined,
}

export default Settings;
